import React from 'react';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { tutorStepPropTypes } from './step-component-props';
import { StyledInstructions } from './instructions';
import contactSupport from '../../media/contactSupport.png';

export const UETTagContactSupport = (props) => {
  const { i18n } = props;
  const text = i18n.getString(_TL_('Our support team can help you work out UET setup instructions.'));
  const content = (
    <p>
      <ReactTemplate template={text} />
    </p>
  );
  const contactSupportUrl = 'https://about.ads.microsoft.com/en-us/microsoft-advertising-support';
  const supportButton = (<DefaultButton id="advertising-support-btn" text={i18n.getString(_TL_('Microsoft Advertising Support'))} onClick={() => window.open(contactSupportUrl)} />);
  const download = null;

  return (
    <React.Fragment>
      <StyledInstructions
        title={i18n.getString(_TL_('Contact Support'))}
        imageSrc={contactSupport}
        descTemp={content}
        downloadInstructions={download}
        button={supportButton}
        i18n={i18n}
      />
    </React.Fragment>
  );
};

UETTagContactSupport.propTypes = tutorStepPropTypes;
